import type {FieldValues} from 'react-hook-form';

import type {
  AnyExportDefinition,
  ExportCell,
  ExportColumn,
} from '../types/exportTypes';

const escapeCsvCell = (cell: ExportCell) => {
  const value = cell === null || cell === undefined ? '' : String(cell);
  if (!/[",\n\r]/.test(value)) return value;

  return `"${value.replaceAll('"', '""')}"`;
};

export const getExportRows = (
  records: unknown[],
  columns: ExportColumn<unknown>[]
) => records.map(record => columns.map(column => column.value(record)));

const getCsvRows = (
  definition: AnyExportDefinition,
  records: unknown[],
  options: FieldValues,
  columns: ExportColumn<unknown>[]
) =>
  definition.toCsvRows?.(records, options, columns) ?? [
    columns.map(column => column.header),
    ...getExportRows(records, columns),
  ];

export const buildCsvFile = (
  definition: AnyExportDefinition,
  records: unknown[],
  options: FieldValues,
  columns: ExportColumn<unknown>[]
) => {
  const content = getCsvRows(definition, records, options, columns)
    .map(row => row.map(escapeCsvCell).join(','))
    .join('\r\n');

  return new Blob([`\uFEFF${content}`], {type: 'text/csv;charset=utf-8'});
};

export const buildClipboardText = (
  records: unknown[],
  columns: ExportColumn<unknown>[]
) =>
  getExportRows(records, columns)
    .map(row => row.map(cell => cell ?? '').join('\t'))
    .join('\n');
